var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 6.55556C17.7408 6.55556 19 5.31189 19 3.77778C19 2.24366 17.7408 1 16.1875 1C14.6342 1 13.375 2.24366 13.375 3.77778C13.375 5.31189 14.6342 6.55556 16.1875 6.55556Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 13.7778C5.36579 13.7778 6.625 12.5341 6.625 11C6.625 9.46593 5.36579 8.22226 3.8125 8.22226C2.25921 8.22226 1 9.46593 1 11C1 12.5341 2.25921 13.7778 3.8125 13.7778Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3749 5.20807L6.25305 9.46968L13.3749 5.20807Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3749 5.20807L6.25305 9.46968",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25305 12.4244L13.757 16.8039L6.25305 12.4244Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25305 12.4244L13.757 16.8039",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 15.4444C17.7408 15.4444 19 16.6881 19 18.2222C19 19.7563 17.7408 21 16.1875 21C14.6342 21 13.375 19.7563 13.375 18.2222C13.375 16.6881 14.6342 15.4444 16.1875 15.4444Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabShare);
export default __webpack_public_path__ + "static/media/tab-share.cd702f52ef2e451789c4c4eea491876c.svg";
export { ForwardRef as ReactComponent };